import Vue from "vue";
import Router from "vue-router";
import DashboardLayout from "@/layout/DashboardLayout";
import theme from "@/config/POPTheme";
import {
    getRole,
    getRoleAuth0
} from "@/plugins/role"

const $ROLE = getRole;

Vue.use(Router);

const [PATH_DROPOFF, PATH_WALLET] = [
    "./views/Report/Dropoff/",
    "./views/Wallet/",
];


let router = new Router({
    mode: 'history',
    linkExactActiveClass: "active",
    routes: [
        {
            path: '*',
            name: 'Not Found',
            component: () =>
                import(/* webpackChunkName: "demo" */ "./views/ERROR/404notfound.vue"),
            meta: {
                guest: true
            }
        },
        {
            path: '/location/timeout',
            name: 'timeout',
            component: () =>
                import(/* webpackChunkName: "demo" */ "./views/ERROR/timeout.vue"),
            meta: {
                lineAuth: true
            }
        },
        {
            path: "/line/manage/sender",
            name: "managesender",
            component: () =>
                import(/* webpackChunkName: "demo" */ "./views/Line/manageSender.vue"),
            meta: {
                lineAuth: true
            }
        },
        {
            path: "/line/book/sender",
            name: "booksender",
            component: () =>
                import(/* webpackChunkName: "demo" */ "./views/Line/BookAllSender.vue"),
            meta: {
                lineAuth: true,
            }
        },
        {
            path: "/line/show/senders",
            component: () =>
                import(/* webpackChunkName: "demo" */ "./views/Line/LineSender.vue"),
            meta: {
                lineAuth: true
            }
        },
        {
            path: "/line/payment/amount",
            name: "paymentamount",
            component: () =>
                import(/* webpackChunkName: "demo" */ "./views/Line/PaymentAmount"),
            meta: {
                lineAuth: true
            }
        },
        {
            path: '/line/download/qrcode',
            name: 'DownLoadQRCode',
            component: () =>
                import(/* webpackChunkName: "demo" */ "./views/Line/downloadQRCode.vue"),
            meta: {
                lineAuth: true
            }
        },
        {
            path: '/line/cancel/order',
            name: 'CancelOrder',
            component: () =>
                import(/* webpackChunkName: "demo" */ "./views/Line/canceltheItem.vue"),
            meta: {
                lineAuth: true
            }
        },
        {
            path: '/line/edit/consign',
            name: 'editConsign',
            component: () =>
                import(/* webpackChunkName: "demo" */ "./views/Line/consignAddress.vue"),
            meta: {
                lineAuth: true
            }
        },
        {
            path: '/line/registerpage',
            name: 'LineRegisterPage',
            component: () =>
                import(/* webpackChunkName: "demo" */ "./views/Line/FillupRegister.vue"),
            meta: {
                lineAuth: true
            }
        },
        {
            path: "/line/action/register",
            name: "registerUsedLine",
            component: () =>
                import(/* webpackChunkName: "demo" */ "./views/Line/registerUsedLine.vue"),
            meta: {
                lineAuth: true,
            },
        },
        {
            path: "/line",
            name: "lineRedirect",
            component: () =>
                import(/* webpackChunkName: "demo" */ "./views/Line/lineinittest.vue"),
            meta: {
                guest: true,
            }
        },
        {
            path: '/line/receipt',
            name: 'lineReceipt',
            component: () =>
                import(/* webpackChunkName: "demo" */ "./views/ReceiptForLine.vue"),
            meta: {
                lineAuth: true
            }
        },
        {
            path: "/order/cancelfeedback",
            name: "cancelorder",
            component: () =>
                import(/* webpackChunkName: "demo" */ "./views/LineLiff/CancelOrder.vue"),
            meta: {
                guest: true,
            },
        },
        {
            path: "/login",
            name: "login",
            component: () =>
                import(/* webpackChunkName: "demo" */ "./views/Login.vue"),
            meta: {
                guest: true,
            },
        },
        {
            path: "/login/admin",
            name: "adminlogin",
            component: () =>
                import(/* webpackChunkName: "demo" */ "./views/Login.vue"),
            meta: {
                guest: true,
            },
        },
        {
            path: "/callback",
            name: "callback",
            component: () =>
                import(/* webpackChunkName: "demo" */ "./views/Callback.vue"),
            meta: {
                guest: true,
            },
        },
        {
            path: "/lead-sale",
            name: "lead-sale",
            component: () =>
                import(/* webpackChunkName: "demo" */ "./views/LeadSale.vue"),
            meta: {
                guest: true,
            },
        },
        {
            path: "/pos",
            name: "pos",
            component: () =>
                import(/* webpackChunkName: "demo" */ "./views/Pos.vue"),
            meta: {
                requiresAuth: true,
                role: [$ROLE.MEMBER, $ROLE.ADMIN],
            },
        },
        {
            path: "/logout",
            name: "logout",
            component: () =>
                import(/* webpackChunkName: "demo" */ "./views/logout.vue"),
            meta: {
                requiresAuth: true,
                role: [],
            },
        },
        {
            path: "/improve",
            name: "improve",
            component: () =>
                import(
                    /* webpackChunkName: "demo" */ "./views/ImproveSystem.vue"
                ),
            meta: {
                requiresAuth: true,
                role: [$ROLE.MEMBER, $ROLE.ADMIN, $ROLE.SUPERADMIN, $ROLE.SHIPPOP],
            },
        },
        {
            path: "/label/inter",
            name: "testtestestlabelinterja",
            component: () =>
                import(
                    /* webpackChunkName: "demo" */ "./views/LabelInter.vue"
                ),
            meta: {
                guest: true
                // requiresAuth: true,
                // role: [$ROLE.MEMBER, $ROLE.ADMIN, $ROLE.SUPERADMIN],
            }
        },
        {
            path: "/label/:labelId/:size",
            name: "label",
            component: () =>
                import(/* webpackChunkName: "demo" */ "./views/LabelHtml.vue"),
            meta: {
                requiresAuth: true,
                role: [$ROLE.MEMBER, $ROLE.ADMIN, $ROLE.SUPERADMIN],
            },
            children: [
                {
                    path: "/label/inter/:orderId/:type",
                    name: "labeldropoffinter",
                    component: () =>
                        import(
                            /* webpackChunkName: "demo" */ "./views/LabelHtml.vue"
                        ),
                    meta: {
                        requiresAuth: true,
                        role: [$ROLE.MEMBER, $ROLE.ADMIN, $ROLE.SUPERADMIN],
                    },
                },
                {
                    path: "/label/:labelId/:size/:type",
                    name: "labeldropoffshippop",
                    component: () =>
                        import(
                            /* webpackChunkName: "demo" */ "./views/LabelHtml.vue"
                        ),
                    meta: {
                        requiresAuth: true,
                        role: [$ROLE.MEMBER, $ROLE.ADMIN, $ROLE.SUPERADMIN],
                    },
                },
                {
                    path: "/label/:type/:orderId/:detailId/:label",
                    name: "customlabel",
                    component: () =>
                        import(
                            /* webpackChunkName: "demo" */ "./views/LabelHtml.vue"
                        ),
                    meta: {
                        requiresAuth: true,
                        role: [$ROLE.MEMBER, $ROLE.ADMIN, $ROLE.SUPERADMIN],
                    },
                },
            ],
        },
        // {
        //     path: "/label/INTER/:orderId",
        //     name: "labelInter",
        //     component: () =>
        //         import( /* webpackChunkName: "demo" */ "./views/LabelInter.vue"),
        //     meta: {
        //         requiresAuth: true,
        //         role: [$ROLE.MEMBER, $ROLE.ADMIN, $ROLE.SUPERADMIN],
        //     }
        // },
        {
            path: "/receipt/:receiptId",
            name: "receipt",
            component: () =>
                import(/* webpackChunkName: "demo" */ "./views/Receipt.vue"),
            meta: {
                requiresAuth: true,
                role: [$ROLE.MEMBER, $ROLE.ADMIN, $ROLE.SUPERADMIN],
            },
        },
        {
            path: "/delivery/:deliveryId",
            name: "delivery",
            component: () =>
                import(/* webpackChunkName: "demo" */ "./views/Delivery.vue"),
            meta: {
                requiresAuth: true,
                role: [$ROLE.MEMBER, $ROLE.ADMIN, $ROLE.SUPERADMIN],
            },
        },
        {
            path: "/report",
            name: "report",
            redirect: "/",
            component: DashboardLayout,
            children: [
                {
                    path: "dropoff",
                    name: "dropoff",
                    component: () => import(PATH_DROPOFF + "Orders.vue"),
                    meta: {
                        requiresAuth: true,
                        role: [
                            $ROLE.SHIPPOP, $ROLE.SUPERADMIN, $ROLE.ADMIN,
                            ...Object.values(getRoleAuth0)
                        ],
                    },
                },
                {
                    path: "wallet/shops",
                    name: "walletshops",
                    component: () =>
                        import(PATH_WALLET + "SuperAdmin/ReportBrance.vue"),
                    meta: {
                        requiresAuth: true,
                        role: [$ROLE.SHIPPOP, $ROLE.MASTER, $ROLE.SUPERADMIN],
                    },
                },
                {
                    path: "invoice",
                    name: "invoice",
                    component: () => {
                        if (theme.menuLayout.reportInvoice) {
                            return import(
                                /* webpackChunkName: "demo" */ "./views/Report/Invoice/ReportInvoice.vue"
                            );
                        }
                    },
                    meta: {
                        requiresAuth: true,
                        role: [$ROLE.SHIPPOP, $ROLE.SUPERADMIN, $ROLE.ADMIN],
                    },
                },
                {
                    path: "receipt",
                    name: "receipt",
                    component: () => {
                        if (theme.menuLayout.reportReceipt) {
                            return import("./views/Report/Receipt/ReportReceipt.vue")
                        }
                    },
                    meta: {
                        requiresAuth: true,
                        role: [$ROLE.SHIPPOP, $ROLE.ADMIN],
                    }
                }
            ],
        },
        {
            path: "/",
            redirect: "dashboard",
            component: DashboardLayout,
            children: [
                {
                    path: "dashboard",
                    name: "dashboard",
                    component: () =>
                        import(
                            /* webpackChunkName: "demo" */ "./views/Dashboard.vue"
                        ),
                    meta: {
                        requiresAuth: true,
                        role: [$ROLE.MEMBER, $ROLE.ADMIN],
                    },
                },
                {
                    path: "cancelorders/:orderId",
                    name: "cancelorders",
                    component: () =>
                        import(
                            /* webpackChunkName: "demo" */ "./views/CancelOrders.vue"
                        ),
                    meta: {
                        requiresAuth: true,
                        role: [$ROLE.MEMBER, $ROLE.ADMIN],
                    },
                },
                {
                    path: "dashboardshippop",
                    name: "dashboardshippop",
                    component: () =>
                        import(
                            /* webpackChunkName: "demo" */ "./views/Dashboardshippop.vue"
                        ),
                    meta: {
                        requiresAuth: true,
                        role: [$ROLE.SUPERADMIN],
                    },
                },
                {
                    path: "product",
                    name: "categoryproduct",
                    component: () =>
                        import(
                            /* webpackChunkName: "demo" */ "./views/Product_V2.vue"
                        ),
                    meta: {
                        requiresAuth: true,
                        role: [$ROLE.ADMIN],
                    },
                },
                {
                    path: "product/:categoryId",
                    name: "product",
                    component: () =>
                        import(
                            /* webpackChunkName: "demo" */ "./views/Product_V2.vue"
                        ),
                    meta: {
                        requiresAuth: true,
                        role: [$ROLE.ADMIN],
                    },
                },
                {
                    path: "categoryservice",
                    name: "categoryservice",
                    component: () =>
                        import(
                            /* webpackChunkName: "demo" */ "./views/Service.vue"
                        ),
                    meta: {
                        requiresAuth: true,
                        role: [$ROLE.ADMIN],
                    },
                },
                {
                    path: "service/:categoryId",
                    name: "service",
                    component: () =>
                        import(
                            /* webpackChunkName: "demo" */ "./views/Service.vue"
                        ),
                    meta: {
                        requiresAuth: true,
                        role: [$ROLE.ADMIN],
                    },
                },
                {
                    path: "profile",
                    name: "profile",
                    component: () =>
                        import(
                            /* webpackChunkName: "demo" */ "./views/UserProfile.vue"
                        ),
                },
                {
                    path: "usersmanage",
                    name: "usersmanage",
                    component: () =>
                        import(
                            /* webpackChunkName: "demo" */ "./views/UsersManage.vue"
                        ),
                    meta: {
                        requiresAuth: true,
                        role: [
                            $ROLE.ADMIN,
                            $ROLE.SHIPPOP,
                            $ROLE.SHIPPOP_ADMINISTRATOR,
                            $ROLE.SHIPPOP_HEAD,
                            $ROLE.SHIPPOP_SENIOR,
                            $ROLE.SHIPPOP_ENGINEER,
                        ],
                    },
                },
                {
                    path: "/transports",
                    name: "transportmanage",
                    component: () =>
                        import(
                            /* webpackChunkName: "demo" */ "./views/TransportManage.vue"
                        ),
                    meta: {
                        requiresAuth: true,
                        role: [
                            $ROLE.ADMIN,
                            $ROLE.SUPERADMIN,
                            $ROLE.SHIPPOP,
                            ...Object.values(getRoleAuth0)
                        ],
                    },
                },
                {
                    path: "/transports/inter",
                    name: "transportintermanage",
                    component: () =>
                        import(
                            /* webpackChunkName: "demo" */ "./views/Inter/TransportInterManage.vue"
                        ),
                    meta: {
                        requiresAuth: true,
                        role: [
                            $ROLE.ADMIN,
                            $ROLE.SUPERADMIN,
                            $ROLE.SHIPPOP,
                            ...Object.values(getRoleAuth0)
                        ],
                    },
                },
                {
                    path: "/transport/inter",
                    name: "transportinter",
                    component: () =>
                        import(
                            /* webpackChunkName: "demo" */ "./views/Inter/TransportInterEdit.vue"
                        ),
                    meta: {
                        requiresAuth: true,
                        role: [$ROLE.ADMIN, $ROLE.SUPERADMIN, $ROLE.SHIPPOP, ...Object.values(getRoleAuth0)],
                    },
                    children: [
                        {
                            path: "/transport/inter/edit/:Id",
                            name: "transportinteredit",
                            component: () =>
                                import(
                                    /* webpackChunkName: "demo" */ "./views/Inter/TransportInterEdit.vue"
                                ),
                            meta: {
                                requiresAuth: true,
                                role: [
                                    $ROLE.SUPERADMIN,
                                    $ROLE.ADMIN,
                                    $ROLE.SHIPPOP,
                                    ...Object.values(getRoleAuth0)
                                ],
                            },
                        },
                    ],
                },
                {
                    path: "/transport",
                    name: "transport",
                    component: () =>
                        import(
                            /* webpackChunkName: "demo" */ "./views/TransportEdit.vue"
                        ),
                    meta: {
                        requiresAuth: true,
                        role: [$ROLE.ADMIN, $ROLE.SUPERADMIN, $ROLE.SHIPPOP],
                    },
                    children: [
                        {
                            path: "/transport/:Id",
                            name: "transportedit",
                            component: () =>
                                import(
                                    /* webpackChunkName: "demo" */ "./views/TransportEdit.vue"
                                ),
                            meta: {
                                requiresAuth: true,
                                role: [
                                    $ROLE.SUPERADMIN,
                                    $ROLE.ADMIN,
                                    $ROLE.SHIPPOP,
                                    ...Object.values(getRoleAuth0)
                                ],
                            },
                        },
                    ],
                },
                {
                    path: "/brancemanage",
                    name: "brancemanage",
                    component: () =>
                        import(
                            /* webpackChunkName: "demo" */ "./views/Brance.vue"
                        ),
                    meta: {
                        requiresAuth: true,
                        role: [
                            $ROLE.ADMIN,
                            $ROLE.SUPERADMIN,
                            $ROLE.SHIPPOP,
                            ...Object.values(getRoleAuth0)
                        ],
                    },
                },
                {
                    path: "/branceedit/:Id",
                    name: "branceedit",
                    component: () =>
                        import(
                            /* webpackChunkName: "demo" */ "./views/BranceEdit.vue"
                        ),
                    meta: {
                        requiresAuth: true,
                        role: [
                            $ROLE.SUPERADMIN,
                            $ROLE.SHIPPOP,
                            ...Object.values(getRoleAuth0)
                        ],
                    },
                },
                {
                    path: "/agent/:Id",
                    name: "agent",
                    component: () =>
                        import(
                            /* webpackChunkName: "demo" */ "./views/Agent.vue"
                        ),
                    meta: {
                        requiresAuth: true,
                        role: [
                            $ROLE.SUPERADMIN,
                            $ROLE.SHIPPOP,
                            $ROLE.SHIPPOP_ADMINISTRATOR,
                            $ROLE.SHIPPOP_HEAD,
                            $ROLE.SHIPPOP_SENIOR,
                            $ROLE.SHIPPOP_SALES,
                            $ROLE.SHIPPOP_ACCOUNTING,
                            $ROLE.SHIPPOP_BUSINESS_DEVELOPMENT,
                        ],
                    },
                },
                {
                    path: "/agentmanage",
                    name: "agentmanage",
                    component: () =>
                        import(
                            /* webpackChunkName: "demo" */ "./views/AgentManage.vue"
                        ),
                    meta: {
                        requiresAuth: true,
                        role: [
                            $ROLE.SHIPPOP,
                            ...Object.values(getRoleAuth0)
                        ],
                    },
                },
                {
                    path: "/branceedit/",
                    name: "adminbranceedit",
                    component: () =>
                        import(
                            /* webpackChunkName: "demo" */ "./views/BranceEdit.vue"
                        ),
                    meta: {
                        requiresAuth: true,
                        role: [
                            $ROLE.ADMIN,
                            $ROLE.SUPERADMIN
                        ],
                    },
                },
                {
                    path: "/reporttransport",
                    name: "reporttransport",
                    component: () =>
                        import(
                            /* webpackChunkName: "demo" */ "./views/Report/ReportTransport.vue"
                        ),
                    meta: {
                        requiresAuth: true,
                        role: [$ROLE.MEMBER, $ROLE.ADMIN],
                    },
                },
                {
                    path: "/reportbrance",
                    name: "reportbrance",
                    component: () =>
                        import(
                            /* webpackChunkName: "demo" */ "./views/Report/ReportBrance.vue"
                        ),
                    meta: {
                        requiresAuth: true,
                        role: [
                            $ROLE.ADMIN, $ROLE.SUPERADMIN, $ROLE.MASTER, $ROLE.SHIPPOP,
                            ...Object.values(getRoleAuth0)
                        ],
                    },
                },
                {
                    path: "/reportcod",
                    name: "reportcod",
                    component: () =>
                        import(
                            /* webpackChunkName: "demo" */ "./views/Report/ReportCod.vue"
                        ),
                    meta: {
                        requiresAuth: true,
                        role: [
                            $ROLE.MEMBER, $ROLE.ADMIN, $ROLE.SUPERADMIN, $ROLE.SHIPPOP,
                            ...Object.values(getRoleAuth0)
                        ],
                    },
                },
                {
                    path: "/reportcod/:Id",
                    name: "reportcodmember",
                    component: () =>
                        import(
                            /* webpackChunkName: "demo" */ "./views/Report/ReportCod.vue"
                        ),
                    meta: {
                        requiresAuth: true,
                        role: [$ROLE.MEMBER, $ROLE.ADMIN, $ROLE.SHIPPOP],
                    },
                },
                {
                    path: "/reportpos",
                    name: "reportpos",
                    component: () =>
                        import(
                            /* webpackChunkName: "demo" */ "./views/Report/ReportPos.vue"
                        ),
                    meta: {
                        requiresAuth: true,
                        role: [$ROLE.ADMIN, $ROLE.SUPERADMIN, $ROLE.SHIPPOP], // superadmin
                    },
                },
                {
                    path: "/reportproduct",
                    name: "reportproduct",
                    component: () =>
                        import(
                            /* webpackChunkName: "demo" */ "./views/Report/ReportProduct.vue"
                        ),
                    meta: {
                        requiresAuth: true,
                        role: [$ROLE.MEMBER, $ROLE.ADMIN],
                    },
                },
                {
                    path: "/reportdropoffshippop",
                    name: "reportdropoffshippop",
                    component: () =>
                        import(
                            /* webpackChunkName: "demo" */ "./views/Report/ReportDropoffShippop.vue"
                        ),
                    meta: {
                        requiresAuth: true,
                        role: [$ROLE.MEMBER, $ROLE.ADMIN],
                    },
                },
                {
                    path: "/reportshippop",
                    name: "reportshippop",
                    component: () =>
                        import(
                            /* webpackChunkName: "demo" */ "./views/Report/ReportShippop.vue"
                        ),
                    meta: {
                        requiresAuth: true,
                        role: [
                            $ROLE.ADMIN,
                            $ROLE.SUPERADMIN,
                            $ROLE.SHIPPOP,
                            ...Object.values(getRoleAuth0)
                        ], // superadmin
                    },
                },
                {
                    path: "/exportdelivery",
                    name: "exportdelivery",
                    component: () =>
                        import(
                            /* webpackChunkName: "demo" */ "./views/ExportDelivery.vue"
                        ),
                    meta: {
                        requiresAuth: true,
                        role: [
                            $ROLE.MEMBER,
                            $ROLE.ADMIN
                        ],
                    },
                },
                {
                    path: "/reportdelivery",
                    name: "reportdelivery",
                    component: () =>
                        import(
                            /* webpackChunkName: "demo" */ "./views/Report/ReportDelivery.vue"
                        ),
                    meta: {
                        requiresAuth: true,
                        role: [$ROLE.MEMBER, $ROLE.ADMIN],
                    },
                },
                {
                    path: "/reportparcel",
                    name: "reportparcel",
                    component: () =>
                        import(
                            /* webpackChunkName: "demo" */ "./views/Report/ReportParcel.vue"
                        ),
                    meta: {
                        requiresAuth: true,
                        role: [$ROLE.ADMIN, $ROLE.SUPERADMIN, $ROLE.MEMBER],
                    },
                },
                {
                    path: "/registermember",
                    name: "registermember",
                    component: () =>
                        import(
                            /* webpackChunkName: "demo" */ "./views/RegisterMember.vue"
                        ),
                    meta: {
                        requiresAuth: true,
                        role: [$ROLE.MEMBER, $ROLE.ADMIN],
                    },
                },
                {
                    path: "/registermember/:email",
                    name: "registermemberbyemail",
                    component: () =>
                        import(
                            /* webpackChunkName: "demo" */ "./views/RegisterMember.vue"
                        ),
                    meta: {
                        requiresAuth: true,
                        role: [$ROLE.MEMBER, $ROLE.ADMIN],
                    },
                },
                {
                    path: "/confirmCommissionSPAdmin",
                    name: "confirmCommissionSPAdmin",
                    component: () =>
                        import(
                            /* webpackChunkName: "demo" */ "./views/ReportVerifyShop/ConfirmShopsCommissionSPAdmin.vue"
                        ),
                    meta: {
                        requiresAuth: true,
                        role: [$ROLE.SUPERADMIN],
                    },
                },
                {
                    path: "/resgisterCommission",
                    name: "resgisterCommission",
                    component: () =>
                        import(
                            /* webpackChunkName: "demo" */ "./views/RegisterCommission.vue"
                        ),
                    meta: {
                        requiresAuth: true,
                        role: [$ROLE.SUPERADMIN],
                    },
                },
                {
                    path: "/verify/:Id",
                    name: "dataverrify",
                    component: () =>
                        import(
                            /* webpackChunkName: "demo" */ "./views/ShowDataVerrify.vue"
                        ),
                    meta: {
                        requiresAuth: true,
                        role: [
                            $ROLE.SUPERADMIN,
                            $ROLE.SHIPPOP,
                            ...Object.values(getRoleAuth0)
                        ],
                    },
                },
                {
                    path: "/verify/shippop/:UserId",
                    name: "verrifyshippop",
                    component: () =>
                        import(
                            /* webpackChunkName: "demo" */ "./views/ShowDataVerrify.vue"
                        ),
                    meta: {
                        requiresAuth: true,
                        role: [
                            $ROLE.SUPERADMIN,
                            $ROLE.SHIPPOP,
                            $ROLE.SHIPPOP_ADMINISTRATOR,
                            $ROLE.SHIPPOP_HEAD,
                            $ROLE.SHIPPOP_SENIOR,
                            $ROLE.SHIPPOP_BUSINESS_DEVELOPMENT,
                            $ROLE.SHIPPOP_CUSTOMER_SERVICE,
                            $ROLE.SHIPPOP_SALES,
                            $ROLE.SHIPPOP_ACCOUNTING,
                        ],
                    },
                },
                {
                    path: "/usershop",
                    name: "usershop",
                    component: () =>
                        import(
                            /* webpackChunkName: "demo" */ "./views/UserShop.vue"
                        ),
                    meta: {
                        requiresAuth: true,
                        role: [
                            $ROLE.SHIPPOP,
                            ...Object.values(getRoleAuth0)
                        ],
                    },
                },
                {
                    path: "/membershop",
                    name: "membershop",
                    component: () =>
                        import(
                            /* webpackChunkName: "demo" */ "./views/Member.vue"
                        ),
                    meta: {
                        requiresAuth: true,
                        role: [
                            $ROLE.MEMBER,
                            $ROLE.ADMIN
                        ],
                    },
                },
                {
                    path: "/flefixparcel",
                    name: "flefixparcel",
                    component: () =>
                        import(
                            /* webpackChunkName: "demo" */ "./views/FlashFixParcel.vue"
                        ),
                    meta: {
                        requiresAuth: true,
                        role: [
                            $ROLE.MEMBER,
                            $ROLE.ADMIN],
                    },
                },
                {
                    path: "/manage/callconfig",
                    name: "managedcallconfig",
                    component: () =>
                        import(
                            /* webpackChunkName: "demo" */ "./views/CallConfig.vue"
                            ),
                    meta: {
                        requiresAuth: true,
                        role: [
                            $ROLE.MEMBER,
                            $ROLE.ADMIN],
                    },
                },
                {
                    path: "/manage/driver",
                    name: "managedriver",
                    component: () =>
                        import(
                            /* webpackChunkName: "demo" */ "./views/ManageDriver.vue"
                        ),
                    meta: {
                        requiresAuth: true,
                        role: [
                            $ROLE.MEMBER,
                            $ROLE.ADMIN],
                    },
                },
                {
                    path: "/shop/commission",
                    name: "shopcommission",
                    component: () =>
                        import(
                            /* webpackChunkName: "demo" */ "./views/ShopCommission.vue"
                        ),
                    meta: {
                        requiresAuth: true,
                        role: [
                            $ROLE.SHIPPOP,
                            ...Object.values(getRoleAuth0)
                        ],
                        // member , admin
                    },
                },
                {
                    path: "/superadmin/commission",
                    name: "superadmincommission",
                    component: () =>
                        import(
                            /* webpackChunkName: "demo" */ "./views/SuperAdminCommission.vue"
                        ),
                    meta: {
                        requiresAuth: true,
                        role: [
                            $ROLE.SHIPPOP,
                            ...Object.values(getRoleAuth0)
                        ],
                        // member , admin
                    },
                },
                {
                    path: "/membercod",
                    name: "membercod",
                    component: () =>
                        import(
                            /* webpackChunkName: "demo" */ "./views/MemberCod.vue"
                        ),
                    meta: {
                        requiresAuth: true,
                        role: [
                            $ROLE.SHIPPOP,
                            ...Object.values(getRoleAuth0)
                        ],
                    },
                },
                {
                    path: "/memberedit/:Id",
                    name: "memberedit",
                    component: () =>
                        import(
                            /* webpackChunkName: "demo" */ "./views/MemberCodEdit.vue"
                        ),
                    meta: {
                        requiresAuth: true,
                        role: [
                            $ROLE.SHIPPOP,
                            ...Object.values(getRoleAuth0)
                        ],
                    },
                },
                {
                    path: "/transfer/statement/cod",
                    name: "statementTransfer",
                    component: () =>
                        import(
                            /* webpackChunkName: "demo" */ "./views/Report/Cod/TransferCodStatement.vue"
                        ),
                    meta: {
                        requiresAuth: true,
                        role: [
                            $ROLE.SHIPPOP,
                            $ROLE.SHIPPOP_ADMINISTRATOR,
                            $ROLE.SHIPPOP_HEAD,
                            $ROLE.SHIPPOP_SENIOR,
                            $ROLE.SHIPPOP_ENGINEER,
                            $ROLE.SHIPPOP_ACCOUNTING,
                            ...Object.values(getRoleAuth0)
                        ],
                    },
                },
                {
                    path: "/createbill/",
                    name: "createbill",
                    component: () =>
                        import(
                            /* webpackChunkName: "demo" */ "./views/Report/Cod/CreateBill.vue"
                        ),
                    meta: {
                        requiresAuth: true,
                        role: [
                            $ROLE.SHIPPOP,
                            $ROLE.SHIPPOP_ADMINISTRATOR,
                            $ROLE.SHIPPOP_HEAD,
                            $ROLE.SHIPPOP_SENIOR,
                            $ROLE.SHIPPOP_ENGINEER,
                            $ROLE.SHIPPOP_ACCOUNTING,
                        ],
                    },
                },
                {
                    path: "/historycancel",
                    name: "historycancel",
                    component: () =>
                        import(
                            /* webpackChunkName: "demo" */ "./views/HistoryCancel.vue"
                        ),
                    meta: {
                        requiresAuth: true,
                        role: [
                            $ROLE.MEMBER,
                            $ROLE.ADMIN],
                    },
                },
                {
                    path: "/changelog",
                    name: "changelog",
                    component: () =>
                        import(
                            /* webpackChunkName: "demo" */ "./views/ChangeLog.vue"
                        ),
                    meta: {
                        requiresAuth: true,
                        role: [
                            $ROLE.ADMIN,
                            $ROLE.SHIPPOP],
                    },
                },
                {
                    path: "/topupcredit",
                    name: "topupcredit",
                    component: () =>
                        import(
                            /* webpackChunkName: "demo" */ "./views/Wallet/Admin/TopUpCredit.vue"
                        ),
                    meta: {
                        requiresAuth: true,
                        role: [$ROLE.ADMIN],
                    },
                },
                {
                    path: "/history/topupwallet",
                    name: "historytopupwallet",
                    component: () =>
                        import(
                            /* webpackChunkName: "demo" */ "./views/Wallet/Admin/HistoryTopUpWallet.vue"
                        ),
                    meta: {
                        requiresAuth: true,
                        role: [$ROLE.ADMIN],
                    },
                },
                {
                    path: "/history/usagewallet",
                    name: "historyusagewallet",
                    component: () =>
                        import(
                            /* webpackChunkName: "demo" */ "./views/Wallet/Admin/HistoryUsageWallet.vue"
                        ),
                    meta: {
                        requiresAuth: true,
                        role: [$ROLE.ADMIN],
                    },
                },
                // {
                //   path: '/notification/topupcredit',
                //   name: 'notificationtopupcredit',
                //   component: () => import(/* webpackChunkName: "demo" */ './views/Wallet/SuperAdmin/NotificationTopUpCredit.vue'),
                //   meta: {
                //     requiresAuth: true,
                //     role: [SUPERADMIN]
                //   }
                // },
                {
                    path: "/history/usagewallet/superadmin",
                    name: "historyusagewalletsuperadmin",
                    component: () =>
                        import(
                            /* webpackChunkName: "demo" */ "./views/Wallet/SuperAdmin/HistoryUsageWallet.vue"
                        ),
                    meta: {
                        requiresAuth: true,
                        role: [$ROLE.SUPERADMIN],
                    },
                },
                {
                    path: "/withdraw/credit",
                    name: "withdrawcredit",
                    component: () =>
                        import(
                            /* webpackChunkName: "demo" */ "./views/Wallet/SuperAdmin/WithDrawCredit.vue"
                        ),
                    meta: {
                        requiresAuth: true,
                        role: [$ROLE.SUPERADMIN],
                    },
                },
                {
                    path: "/topupcredit/shop",
                    name: "topupcredittoshop",
                    component: () =>
                        import(
                            /* webpackChunkName: "demo" */ "./views/Wallet/SuperAdmin/TopUpCreditToShop.vue"
                        ),
                    meta: {
                        requiresAuth: true,
                        role: [$ROLE.SUPERADMIN],
                    },
                },
                {
                    path: "/history/topupcredit/superadmin",
                    name: "historytopupwallettoshop",
                    component: () =>
                        import(
                            /* webpackChunkName: "demo" */ "./views/Wallet/SuperAdmin/HistoryTopUpWalletToShop.vue"
                        ),
                    meta: {
                        requiresAuth: true,
                        role: [$ROLE.SUPERADMIN],
                    },
                },
                {
                    path: "/creditbalance/shop",
                    name: "creditbalanceshop",
                    component: () =>
                        import(
                            /* webpackChunkName: "demo" */ "./views/Wallet/SuperAdmin/CreditBalanceShop.vue"
                        ),
                    meta: {
                        requiresAuth: true,
                        role: [$ROLE.SUPERADMIN],
                    },
                },
                {
                    path: "/reportoverweight",
                    name: "reportoverweight",
                    component: () =>
                        import(
                            /* webpackChunkName: "demo" */ "./views/Wallet/SuperAdmin/ReportOverWeight.vue"
                        ),
                    meta: {
                        requiresAuth: true,
                        role: [$ROLE.SUPERADMIN],
                    },
                },
                {
                    path: "/history/topbalance",
                    name: "historytopbalance",
                    component: () =>
                        import(
                            /* webpackChunkName: "demo" */ "./views/Wallet/Shippop/HistoryTopBalance.vue"
                        ),
                    meta: {
                        requiresAuth: true,
                        role: [
                            $ROLE.SHIPPOP,
                            $ROLE.SHIPPOP_ADMINISTRATOR,
                            $ROLE.SHIPPOP_HEAD,
                            $ROLE.SHIPPOP_SENIOR,
                            $ROLE.SHIPPOP_ENGINEER,
                            $ROLE.SHIPPOP_CUSTOMER_SERVICE,
                            $ROLE.SHIPPOP_MARKETING,
                            $ROLE.SHIPPOP_SALES,
                            $ROLE.SHIPPOP_ACCOUNTING,
                            $ROLE.SHIPPOP_JUNIOR,
                            $ROLE.SHIPPOP_INTERN,
                        ],
                    },
                },
                {
                    path: "/history/topup",
                    name: "historytopup",
                    component: () =>
                        import(
                            /* webpackChunkName: "demo" */ "./views/Wallet/Shippop/HistoryTopUpWallet.vue"
                        ),
                    meta: {
                        requiresAuth: true,
                        role: [
                            $ROLE.SHIPPOP,
                            $ROLE.SHIPPOP_ADMINISTRATOR,
                            $ROLE.SHIPPOP_HEAD,
                            $ROLE.SHIPPOP_SENIOR,
                            $ROLE.SHIPPOP_ENGINEER,
                            $ROLE.SHIPPOP_CUSTOMER_SERVICE,
                            $ROLE.SHIPPOP_MARKETING,
                            $ROLE.SHIPPOP_SALES,
                            $ROLE.SHIPPOP_ACCOUNTING,
                            $ROLE.SHIPPOP_JUNIOR,
                            $ROLE.SHIPPOP_INTERN,
                        ],
                    },
                },
                {
                    path: "/tracking",
                    name: "tracking",
                    component: () =>
                        import(
                            /* webpackChunkName: "demo" */ "./views/Tracking.vue"
                        ),
                    meta: {
                        requiresAuth: true,
                        role: [
                            $ROLE.MEMBER,
                            $ROLE.ADMIN,
                            $ROLE.SUPERADMIN,
                            $ROLE.SHIPPOP,
                            ...Object.values(getRoleAuth0)
                        ],
                    },
                },
                {
                    path: "/ratemanagement/:Id",
                    name: "ratemanagement",
                    component: () =>
                        import(
                            /* webpackChunkName: "demo" */ "./views/RateManagement.vue"
                        ),
                    meta: {
                        requiresAuth: true,
                        role: [
                            $ROLE.SUPERADMIN,
                            $ROLE.SHIPPOP,
                            $ROLE.SHIPPOP_ADMINISTRATOR,
                            $ROLE.SHIPPOP_HEAD,
                            $ROLE.SHIPPOP_SENIOR,
                            $ROLE.SHIPPOP_BUSINESS_DEVELOPMENT,
                            $ROLE.SHIPPOP_CUSTOMER_SERVICE,
                            $ROLE.SHIPPOP_SALES,
                            $ROLE.SHIPPOP_ACCOUNTING
                        ],
                    },
                },
                {
                    path: "/inter/ratemanagement/:Id",
                    name: "interRatemanagement",
                    component: () =>
                        import(
                            /* webpackChunkName: "demo" */ "./views/InterRateManagement.vue"
                        ),
                    meta: {
                        requiresAuth: true,
                        role: [
                            $ROLE.SUPERADMIN,
                            $ROLE.SHIPPOP,
                            $ROLE.SHIPPOP_ADMINISTRATOR,
                            $ROLE.SHIPPOP_HEAD,
                            $ROLE.SHIPPOP_SENIOR,
                            $ROLE.SHIPPOP_BUSINESS_DEVELOPMENT,
                            $ROLE.SHIPPOP_CUSTOMER_SERVICE,
                            $ROLE.SHIPPOP_SALES,
                            $ROLE.SHIPPOP_ACCOUNTING
                        ],
                    },
                },
                {
                    path: "/waiveinvoice",
                    name: "waiveinvoice",
                    component: () =>
                        import(
                            /* webpackChunkName: "demo" */ "./views/WaiveInvoice.vue"
                        ),
                    meta: {
                        requiresAuth: true,
                        role: [
                            $ROLE.SHIPPOP,
                            $ROLE.SHIPPOP_ADMINISTRATOR,
                            $ROLE.SHIPPOP_HEAD,
                            $ROLE.SHIPPOP_SENIOR,
                            $ROLE.SHIPPOP_CUSTOMER_SERVICE,
                            $ROLE.SHIPPOP_MARKETING,
                        ],
                    },
                },
                {
                    path: "/fakecustomer",
                    name: "fakecustomer",
                    component: () =>
                        import(
                            /* webpackChunkName: "demo" */ "./views/FakeCustomer.vue"
                        ),
                    meta: {
                        requiresAuth: true,
                        role: [
                            $ROLE.SHIPPOP,
                            ...Object.values(getRoleAuth0)
                        ],
                    },
                },
                {
                    path: "manage/cod",
                    name: "managecod",
                    component: () => import(/* webpackChunkName: "demo" */ "./views/Cod/ManageCod.vue"),
                    meta: {
                        requiresAuth: true,
                        role: [$ROLE.SHIPPOP],
                    }
                },
                {
                    path: "/setting/line",
                    name: "settingline",
                    component: () =>
                        import(
                            /* webpackChunkName: "demo" */ "./views/Line/SettingLine.vue"
                        ),
                    meta: {
                        requiresAuth: true,
                        role: [
                            $ROLE.ADMIN
                        ],
                    },
                },
            ],
        },
        {
          path: "/callback/wallet-verification",
          name: "callbackwalletverification",
          component: () => import(/* webpackChunkName: "demo" */ "./views/Callback/WalletVerification.vue"),
          meta: {
            requiresAuth: true,
            role: [
                $ROLE.ADMIN
            ],
          }
        },
        {
            path: "/coupon",
            name: "coupon",
            redirect: "/",
            component: DashboardLayout,
            children: [
                {
                    path: "coupon-list",
                    name: "couponlist",
                    component: () => import(/* webpackChunkName: "demo" */ "./views/Coupon/CouponList.vue"),
                    meta: {
                      requiresAuth: true,
                      role: [
                        $ROLE.ADMIN,
                        $ROLE.SUPERADMIN,
                        $ROLE.SHIPPOP,
                        $ROLE.MEMBER,
                        ...Object.values(getRoleAuth0)
                      ],
                    }
                  }
            ]
        }
    ],
});
router.beforeEach((to, from, next) => {
    if (to.matched.some((record) => record.meta.requiresAuth)) {
        if (localStorage.getItem("access_token") == null) {
            next({
                path: "/login",
                query: {
                    redirect: to.fullPath,
                },
                params: {
                    nextUrl: to.fullPath,
                },
            });
        } else {
            let user = JSON.parse(localStorage.getItem("user"));
            if (user) {
                const provider = user.provider ? true : false;
                let role = user.role;
                let role_auth0 = provider ? user.role_auth0 : [];
                let token_expire = user.exp;
                if (token_expire <= Date.now() / 1000) {
                    localStorage.removeItem("access_token");
                    localStorage.removeItem("user");
                    next({
                        path: "login",
                    });
                } else if (
                    ("role" in to.meta &&
                        to.meta.role.includes(role) &&
                        (provider ? to.meta.role.some((r) => role_auth0.includes(r)) : true) && to.meta.role) || to.name == "logout"
                ) {
                    next();
                } else {
                    localStorage.removeItem("access_token");
                    localStorage.removeItem("user");
                    next({
                        path: "login",
                    });
                }
            } else {
                localStorage.removeItem("access_token");
                next({
                    path: "login",
                });
            }
        }
    }else if(to.matched.some((record) => record.meta.lineAuth)) {
        if(localStorage.getItem("access_token_line") == null) {
            next({
                path: "/404FOUND",
            });
        }else {
            next();
        }
    } else if (to.matched.some((record) => record.meta.guest)) {
        // if (localStorage.getItem("access_token") == null) {
            next();
        // } else {
        //     next({
        //         path: "/",
        //     });
        // }
    }
});

export default router;
